import { Target, TrendingUp, Handshake, Users, Globe, Shield } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import type { TranslationKey } from "@/i18n/translations";

const areas: { icon: typeof Target; key: TranslationKey }[] = [
  { icon: Target, key: "help.item1" },
  { icon: TrendingUp, key: "help.item2" },
  { icon: Handshake, key: "help.item3" },
  { icon: Users, key: "help.item4" },
  { icon: Globe, key: "help.item5" },
  { icon: Shield, key: "help.item6" },
];

const WhatIHelpWithSection = () => {
  const { t } = useLanguage();

  return (
    <section id="what-i-help-with" className="py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16 space-y-4">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
              {t("help.title")}
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-serif">
              {t("help.subtitle")}
            </p>
          </div>

          <div className="mb-8 text-center">
            <p className="text-sm font-medium text-muted-foreground uppercase tracking-widest mb-8">
              {t("help.focusLabel")}
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {areas.map((area) => (
              <div
                key={area.key}
                className="flex items-center gap-4 p-6 bg-secondary/30 rounded-sm border border-border/30 hover:border-accent/30 transition-colors"
              >
                <div className="h-12 w-12 rounded-sm bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <area.icon className="h-6 w-6 text-accent" />
                </div>
                <p className="text-foreground font-medium">{t(area.key)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIHelpWithSection;
